import { FC, useRef } from 'react';
import { Flex } from 'antd';
import {
  SDropdown,
  ErrorMessage,
  SLabelTitle,
  ModalDialog,
  StatusDropdown,
  UploadButton,
  SInput,
  SDatePicker,
} from '../..';
import { IProps } from './type';
import styles from '../../../assets/styles/index.module.scss';
import { useAppSelector } from '../../../store';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { DATE_FORMAT } from '../../../assets/conts';
import { modalTypes } from '../../../assets/enums';
import { useSetOrganizationOnOpen } from '../../../hooks';

dayjs.extend(customParseFormat);

const GroupHealthInsurancePoliciesModal: FC<IProps> = (props) => {
  const { getFieldProps, setFieldValue, values, errors, touched } =
    props.formik;
  const uploadInput = useRef<HTMLInputElement | null>(null);
  const { organization } = useAppSelector(
    (state) => state.userReducer.userInfo,
  );

  useSetOrganizationOnOpen(props.open, values, setFieldValue);

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={props.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical>
        <Flex gap="small" vertical>
          <SLabelTitle>Şirket Bilgileri</SLabelTitle>
          <Flex vertical gap="small" className={styles.widthHalf}>
            <SDropdown
              id="organization"
              value={
                props.organizations.find(
                  (item) =>
                    item.id ===
                    (values.organization ||
                      (organization !== 1 ? organization : undefined)),
                )?.name
              }
              placeholder="Şirket Seçiniz"
              disabled={organization !== 1}
              options={props.organizations.map((item) => ({
                value: item.id,
                label: item.name,
              }))}
              onChange={(value) => setFieldValue('organization', value)}
            />
            {touched.organization && errors.organization && (
              <ErrorMessage>{errors.organization}</ErrorMessage>
            )}
          </Flex>
        </Flex>
        <Flex gap="small" vertical>
          <SLabelTitle>Poliçe Bilgileri</SLabelTitle>
          <Flex gap="small">
            <Flex vertical gap="small" className={styles.widthOneThird}>
              <SInput
                placeholder="Poliçe No"
                {...getFieldProps('policy_number')}
              />
              {touched.policy_number && errors.policy_number && (
                <ErrorMessage>{errors.policy_number}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={styles.widthOneThird}>
              <SDropdown
                id="doc_type"
                value={
                  props.policyTypes.find((item) => item.key === values.doc_type)
                    ?.value
                }
                placeholder="Poliçe Tipi"
                options={props.policyTypes.map((item) => ({
                  value: item.key,
                  label: item.value,
                }))}
                onChange={(value) => setFieldValue('doc_type', value)}
              />
              {touched.doc_type && errors.doc_type && (
                <ErrorMessage>{errors.doc_type}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={styles.widthOneThird}>
              <SDropdown
                id="branch"
                value={
                  props.branch.find((item) => item.key === values.branch)?.value
                }
                placeholder="Branş"
                options={props.branch.map((item) => ({
                  value: item.key,
                  label: item.value,
                }))}
                onChange={(value) => setFieldValue('branch', value)}
              />
              {touched.branch && errors.branch && (
                <ErrorMessage>{errors.branch.toString()}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        <UploadButton
          fileName={[...values.upload_files]?.map((item) => item.name)}
          uploadRef={uploadInput}
          onChange={props.handleUploadFile}
        />
        <Flex gap="small" vertical>
          <SLabelTitle>Başlangıç - Bitiş Tarihi</SLabelTitle>
          <Flex justify="space-between" gap="small">
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SDatePicker
                id="start_date"
                name="start_date"
                value={
                  values.start_date
                    ? dayjs(values.start_date, DATE_FORMAT)
                    : null
                }
                placeholder="Başlangıç Tarihi"
                onChange={(date) => {
                  if (date) {
                    setFieldValue('start_date', date.format(DATE_FORMAT));
                  }
                }}
              />
              {touched.start_date && errors.start_date && (
                <ErrorMessage>{errors.start_date}</ErrorMessage>
              )}
            </Flex>
            <Flex vertical gap="small" className={styles.widthHalf}>
              <SDatePicker
                id="end_date"
                name="end_date"
                value={
                  values.end_date ? dayjs(values.end_date, DATE_FORMAT) : null
                }
                placeholder="Bitiş Tarihi"
                onChange={(date) => {
                  if (date) {
                    setFieldValue('end_date', date.format(DATE_FORMAT));
                  }
                }}
              />
              {touched.end_date && errors.end_date && (
                <ErrorMessage>{errors.end_date}</ErrorMessage>
              )}
            </Flex>
          </Flex>
        </Flex>
        {props.type === modalTypes.EDIT && organization === 1 && (
          <Flex justify="space-between">
            <SLabelTitle>Durum Bilgisi</SLabelTitle>
            <StatusDropdown
              status={values.recent_status}
              statusChoices={props.statusChoices}
              onChange={(value) => setFieldValue('recent_status', value)}
            />
          </Flex>
        )}
      </Flex>
    </ModalDialog>
  );
};

export default GroupHealthInsurancePoliciesModal;
